/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMyBankAccountCommand
 */
export interface CreateMyBankAccountCommand {
    /**
     * International Bank Account Number
     * @type {string}
     * @memberof CreateMyBankAccountCommand
     */
    iban: string;
    /**
     * Bank Identifier Code (BIC/SWIFT)
     * @type {string}
     * @memberof CreateMyBankAccountCommand
     */
    bic?: string | null;
    /**
     * Label or name of the bank account
     * @type {string}
     * @memberof CreateMyBankAccountCommand
     */
    label: string;
    /**
     * Indicates if this should be the default bank account
     * @type {boolean}
     * @memberof CreateMyBankAccountCommand
     */
    isDefault?: boolean;
}

/**
 * Check if a given object implements the CreateMyBankAccountCommand interface.
 */
export function instanceOfCreateMyBankAccountCommand(value: object): value is CreateMyBankAccountCommand {
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function CreateMyBankAccountCommandFromJSON(json: any): CreateMyBankAccountCommand {
    return CreateMyBankAccountCommandFromJSONTyped(json, false);
}

export function CreateMyBankAccountCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMyBankAccountCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'iban': json['iban'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'label': json['label'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
    };
}

export function CreateMyBankAccountCommandToJSON(json: any): CreateMyBankAccountCommand {
    return CreateMyBankAccountCommandToJSONTyped(json, false);
}

export function CreateMyBankAccountCommandToJSONTyped(value?: CreateMyBankAccountCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'iban': value['iban'],
        'bic': value['bic'],
        'label': value['label'],
        'isDefault': value['isDefault'],
    };
}

